// extracted by mini-css-extract-plugin
module.exports = {"cartButton":"product-detail_cartButton__1I6jl","cartItems":"product-detail_cartItems__2vEMV","title":"product-detail_title__1Q7Yb"};